(() => {
  if (customElements.get('pu-benefit-slider')) return;
  class PerfectUtilBenefits extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-benefit-slide]')];
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.classList.add('is-ready');
      this.querySelector('[data-benefit-controls]').hidden = false;
      this.addEventListener('pointerenter', () => { this.hovered = true; this.restart(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.restart(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.restart(); }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.restart();
      }, options);
      document.addEventListener('visibilitychange', () => this.restart(), options);
      this.show(false);
      this.restart();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
    show(announce) {
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      const count = this.querySelector('[data-benefit-count]');
      count.setAttribute('aria-live', announce ? 'polite' : 'off');
      count.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    restart() {
      clearInterval(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.slides.length;
        this.show(false);
      }, Number(this.dataset.interval) || 5500);
    }
  }
  customElements.define('pu-benefit-slider', PerfectUtilBenefits);
})();
